import { render, staticRenderFns } from "./OrderCartPreviewList.vue?vue&type=template&id=05d2b3e2&scoped=true&"
import script from "./OrderCartPreviewList.vue?vue&type=script&lang=js&"
export * from "./OrderCartPreviewList.vue?vue&type=script&lang=js&"
import style0 from "./OrderCartPreviewList.vue?vue&type=style&index=0&id=05d2b3e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d2b3e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VChip,VCol,VContainer,VIcon,VRow,VSkeletonLoader})
